export enum LocalizationKeys {
    TileName = 'relocation-limits',

    CreateRelocationLimit = 'RL_CreateRelocationLimit',
    EditRelocationLimit = 'RL_EditRelocationLimit',
    DeleteRelocationLimit = 'RL_DeleteRelocationLimit',

    TableColumnChannelName = 'RL_TableColumnChannelName',
    TableColumnStartDate = 'RL_TableColumnStartDate',
    TableColumnEndDate = 'RL_TableColumnEndDate',
    TableColumnVolume = 'RL_TableColumnVolume',
    TableColumnWeightLimit = 'RL_TableColumnWeightLimit',

    RelocationLimitCreateFormTitle = 'RL_RelocationLimitCreateFormTitle',
    RelocationLimitEditFormTitle = 'RL_RelocationLimitEditFormTitle',
    DialogOk = 'DialogOk',
    DialogCancel = 'DialogCancel',
    DialogClose = 'DialogClose',
    DialogRepeate = 'DialogRepeate',
    RelocationLimitForm_ChannelLabel = 'RL_RelocationLimitForm_ChannelLabel',
    RelocationLimitForm_StartDateLabel = 'RL_RelocationLimitForm_StartDateLabel',
    RelocationLimitForm_EndDateLabel = 'RL_RelocationLimitForm_EndDateLabel',
    RelocationLimitForm_WeightLimitLabel = 'RL_RelocationLimitForm_WeightLimitLabel',
    RelocationLimitForm_VolumeLimitLabel = 'RL_RelocationLimitForm_VolumeLimitLabel',
    RelocationLimitForm_OperationError = 'RL_RelocationLimitForm_OperationError',
    RelocationLimitForm_ErrorAdvise = 'RL_RelocationLimitForm_ErrorAdvise',
    RelocationLimitForm_ValidationSelectChannel = 'RL_RelocationLimitForm_ValidationSelectChannel',
    RelocationLimitForm_ValidationStartDateRequired = 'RL_RelocationLimitForm_ValidationStartDateRequired',
    RelocationLimitForm_ValidationStartDateErlier = 'RL_RelocationLimitForm_ValidationStartDateErlier',
    RelocationLimitForm_ValidationEndDateRequired = 'RL_RelocationLimitForm_ValidationEndDateRequired',
    RelocationLimitForm_ValidationEndDateLater = 'RL_RelocationLimitForm_ValidationEndDateLater',
    RelocationLimitForm_ValidationWeightLimitGEZero = 'RL_RelocationLimitForm_ValidationWeightLimitGEZero',
    RelocationLimitForm_ValidationVolumeLimitGEZero = 'RL_RelocationLimitForm_ValidationVolumeLimitGEZero',

    RelocationLimitDeleteError_FormTitle = 'RL_RelocationLimitDeleteError_FormTitle',
    RelocationLimitDeleteError_PreMessageText = 'RL_RelocationLimitDeleteError_PreMessageText',
    RelocationLimitDeleteError_PostMessageText = 'RL_RelocationLimitDeleteError_PostMessageText',
}
